// src/index.js

import "./motomate-widget"; // defines <motomate-chat>
// import "./motomate.v1.js"; // dealer loader

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Embed from "./embed.jsx";
import SuccessPage from "./SuccessPage";
import CancelPage from "./CancelPage";

// (you already have this ready ping – fine to keep)
if (window.parent) {
  window.parent.postMessage({ type: "MOTOMATE_WIDGET_READY" }, "*");
}

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/embed" element={<Embed />} />
      <Route path="/success" element={<SuccessPage />} />
      <Route path="/cancel" element={<CancelPage />} />
    </Routes>
  </BrowserRouter>
);
